import { css } from "styled-components";
// 페이지별 카드·링크 묶음에 공통으로 쓰는 스타일 조각
export const card = css`
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
`;
export const softCard = css`
  border-radius: ${({ theme }) => theme.radius};
  background-color: ${({ theme }) => theme.colors.monotone.extralight};
`;
export const navyCard = css`
  border-radius: ${({ theme }) => theme.radius};
  background: radial-gradient(circle at 90% 0%, rgba(1, 101, 172, 0.45), transparent 55%),
    linear-gradient(135deg, ${({ theme }) => theme.colors.ink}, ${({ theme }) => theme.colors.dark});
  color: white;
`;
// "… 보기 →" 링크 여러 개를 알약 모양 버튼으로
export const linkPills = css`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  & > a {
    padding: 0.7rem 1.3rem;
    border-radius: 999px;
    border: 1px solid ${({ theme }) => theme.colors.line};
    background-color: white;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.dark};
    transition: border-color 0.2s, color 0.2s, background-color 0.2s;
    &:hover {
      border-color: ${({ theme }) => theme.colors.accent};
      color: ${({ theme }) => theme.colors.accent};
      background-color: ${({ theme }) => theme.colors.accentSoft};
    }
  }
`;
